const seon = 'seondnsresolve.com';
const sentry = 'sentry.sunfinance.ninja';
const proxyPath = `${location.origin}/proxy`;
const MAX_RETRY_COUNT = 1;

function retryRequest(originalXHR, modifiedUrl) {
  if (originalXHR._retryCount > MAX_RETRY_COUNT) return;

  const xhr = new XMLHttpRequest();

  xhr.open(originalXHR._method, modifiedUrl);
  xhr._retryCount = originalXHR._retryCount;

  for (const header in originalXHR._headers) {
    xhr.setRequestHeader(header, originalXHR._headers[header]);
  }

  xhr.setRequestHeader('url', originalXHR._url);
  xhr.send(originalXHR._body);
}

export default function() {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._method = method;
    this._url = url;
    this._headers = {};
    this._body = null;
    this._retryCount = 0;

    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.setRequestHeader = function(header, value) {
    this._headers[header] = value;
    return originalSetRequestHeader.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    this._body = body;

    this.addEventListener('error', () => {
      const includes = this._url.includes(seon);

      if (includes) {
        this._retryCount++;
        retryRequest(this, proxyPath);
      }
    });

    return originalSend.apply(this, arguments);
  };

  const originalFetch = window.fetch;

  window.fetch = (url, options = {}) =>
    originalFetch(url, options)
      .then(res => (res.ok ? res : Promise.reject(res)))
      .catch(() => {
        const includes = url.includes(sentry);
        options.headers = { ...options.headers, url };
        includes && originalFetch(proxyPath, options);
      });
}
